import { mutateAdmin, queryAdmin } from '../graphql-client';

const roleFragment = /* GraphQL */ `
  name
  permissions
  conditions
  created
  updated
  builtIn
`;

export const GET_ROLE_LIST = /* GraphQL */ `
  query getRoleList {
    result: getRoleList {
      items {
        ${roleFragment}
      }
      total
    }
  }
`;

export const GET_ROLE = /* GraphQL */ `
  query getRole($name: String!) {
    result: getRole(name: $name) {
      ${roleFragment}
    }
  }
`;

export const CREATE_ROLE_MUTATION = /* GraphQL */ `
  mutation ($input: TSRoleInput!) {
    createRole(input: $input) {
      ${roleFragment}
    }
  }
`;

export const UPDATE_ROLE_MUTATION = /* GraphQL */ `
  mutation ($input: TSRoleInput!) {
    updateRole(input: $input) {
      ${roleFragment}
    }
  }
`;

export const REMOVE_ROLE_MUTATION = /* GraphQL */ `
  mutation ($name: String!) {
    deleteRole(name: $name)
  }
`;

export const createRole = mutateAdmin(CREATE_ROLE_MUTATION);
export const updateRole = mutateAdmin(UPDATE_ROLE_MUTATION);
export const removeRole = mutateAdmin(REMOVE_ROLE_MUTATION);
export const getRoleList = queryAdmin(GET_ROLE_LIST);
export const getRole = queryAdmin(GET_ROLE);
